<template>
  <div class="pie-chart-div">
    <!-- pie-chart 컴포넌트에 chartData, chartOptions, 사이즈 props 전달 -->
    <pie-chart :data="chartData[0]" :options="chartOptions" :width="width" :height="height"></pie-chart>
  </div>
</template>

<script>
import PieChart from '../../../pieChart';  // PieChart 컴포넌트 임포트
import ChartJSPluginDatalabels from "chartjs-plugin-datalabels"; // (사용 여부 확인 필요)

export default {
  name: "App",
  components: {
    PieChart
  },
  props: {
    chartOptions: {       // 차트 옵션 객체 (차트 설정용)
      type: Object,
    },
    perData: {            // 차트에 표현할 데이터 배열 (예: 퍼센트 데이터)
      type: Array,
      default: () => []
    },
    width: {              // 차트 너비
      type: Number,
      default: 220
    },
    height: {             // 차트 높이
      type: Number,
      default: 220
    },
  },
  watch: {
    // perData 배열이 변경되면 차트 데이터 갱신
    perData: {
      handler: function () {
        // 임시 차트 데이터를 perData 값으로 업데이트
        this.tempChartData.datasets[0].data = this.perData;

        // 기존 chartData 복사 후 첫 번째 요소를 업데이트한 tempChartData로 대체
        const newList = [...this.chartData];
        newList.splice(0, 1, this.tempChartData);
        this.chartData = newList; // 반응형 갱신 트리거
      },
      deep: true
    }
  },
  data() {
    return {
      // 차트에 전달할 기본 데이터 구조 (첫 번째 데이터셋 초기값)
      chartData: [{
        datasets: [
          {
            backgroundColor: ['#F5F5F5', '#FFCD00'], // 각 데이터셋의 색상
            data: [0, 0]                            // 초기 데이터 값
          }
        ]
      }],
      // 임시 데이터로 watch 내 수정용 객체
      tempChartData: {
        datasets: [
          {
            backgroundColor: ['#F5F5F5', '#FFCD00'],
            data: [0, 0]
          }
        ]
      },
    }
  }
};
</script>

<style scoped>
/* 필요 시 스타일 추가 가능 */
</style>
